"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgDumbbellFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M6 16a3.998 3.998 0 003.465-2h5.077c.198.388 1.263 2 3.458 2 2.427 0 4-2 4-4 0-2.44-2.026-4-4-4-1.522 0-2.938.934-3.458 2.007 0 0-5.073-.007-5.073 0A4 4 0 106 16z' }))); };
exports.default = SvgDumbbellFilled;
//# sourceMappingURL=DumbbellFilled.js.map